import axios from 'axios';
import fileTyper from 'file-type';
import Api from './api';
import EventBus from './eventBus';
import Helper from './pages/helper';
import Constants from './constants';
import * as Types from './store/mutation-types';
import Modals from './constants/CustomModals';
import { isAnalyticsLoaded, isMarketingLoaded, trackGoogleConversion } from './utils/cookieConsent';

import { mapState } from 'vuex'
import store from './store'
import NodeApi from '@/utils/request'

//import LogRocket from 'logrocket';

export default {
  methods: {
    slugify(text) {
      const trMap = {
        'çÇ':'c',
        'ğĞ':'g',
        'şŞ':'s',
        'üÜ':'u',
        'ıİ':'i',
        'öÖ':'o'
      };
      for(const key in trMap) {
        text = text.replace(new RegExp('['+key+']','g'), trMap[key]);
      }
      return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '') // remove non-alphanumeric chars
        .replace(/\s/gi, "-") // convert spaces to dashes
        .replace(/[-]+/gi, "-") // trim repeated dashes
        .toLowerCase();

    },
    handleGlobalClick(whereFrom, clickedFrom, type= '', impressionUUID = null, info= {}){
      if (type === 'gig'){
        this.Helper.trackEvents.customEvent("gig_clicks", {title:impressionUUID, ...info});
      }
      window.localStorage.setItem("whereFrom",  this.$store.state.componentMap.page);
      window.localStorage.setItem("clickedFrom", clickedFrom);
      if(clickedFrom){
        this.$store.state.clickedFrom = clickedFrom;
      }
    },
    placeCaretAtEnd(el) {
      el.focus();
      if (typeof window.getSelection !== 'undefined'
        && typeof document.createRange !== 'undefined') {
        let range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange !== 'undefined') {
        let textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    uploadFileToGoogle(file, type, externalID, stamp = +new Date(), r_id = '', r_uuid = '', videoDuration = 0) {

      let cancel;
      let cancelToken = axios.CancelToken;

      const uploadType = type === 'message' ? externalID : type;

      const updateUploadState = ({status, percentage, clearMetadata = false}) => {
        if (status !== undefined) {
          const uploadStatus = this.$store.state.uploadStatus || {};
          this.$store.state.uploadStatus = {
            ...uploadStatus,
            [uploadType]: {
              ...(uploadStatus[uploadType] || {}),
              [stamp]: status
            }
          };
        }

        if (percentage !== undefined || clearMetadata) {
          const percentCompleted = this.$store.state.percentCompleted || {};
          const nextPercentCompleted = {
            ...percentCompleted,
            [uploadType]: {
              ...(percentCompleted[uploadType] || {})
            }
          };

          if (percentage !== undefined) {
            nextPercentCompleted[uploadType][stamp] = percentage;
          }

          if (clearMetadata) {
            const tempIcons = {...(percentCompleted.temp_icon_png || {})};
            const fileNames = {...(percentCompleted.fileNames || {})};
            delete tempIcons[stamp];
            delete fileNames[stamp];
            nextPercentCompleted.temp_icon_png = tempIcons;
            nextPercentCompleted.fileNames = fileNames;
          }

          this.$store.state.percentCompleted = nextPercentCompleted;
        }
      };

      const updateUploadMetadata = (icon, fileName) => {
        const percentCompleted = this.$store.state.percentCompleted || {};
        this.$store.state.percentCompleted = {
          ...percentCompleted,
          temp_icon_png: {
            ...(percentCompleted.temp_icon_png || {}),
            [stamp]: icon
          },
          fileNames: {
            ...(percentCompleted.fileNames || {}),
            [stamp]: fileName
          }
        };
      };

      updateUploadState({status: "started", percentage: 0.1});

      return new Promise((resolve, reject) => {
        let settled = false;
        let cancelRequested = false;
        let cancelUploadHandler = null;
        let maxBlockSize = 256 * 1024;
        let currentFilePointer = 0;
        let totalBytesRemaining = 0;
        let blockIds = [];
        let blockIdPrefix = "block-";
        let submitUri = null;
        let bytesUploaded = 0;


        let fileSize = file.size;
        let fileName = file.name;
        let fileType = file.type;

        if (fileSize < maxBlockSize) {
          maxBlockSize = fileSize;
        }
        totalBytesRemaining = fileSize;



        let tempFileReader = new FileReader();
        let uploadingFileBlockCount = 0;

        const cleanupCancelListener = () => {
          if (cancelUploadHandler) {
            EventBus.$off('cancelUpload', cancelUploadHandler);
            cancelUploadHandler = null;
          }
        };

        const getVideoDuration = file => new Promise((resolveDuration, rejectDuration) => {
          const video = document.createElement('video');
          const fileURL = URL.createObjectURL(file);

          const cleanup = () => {
            video.onloadedmetadata = null;
            video.onseeked = null;
            video.onerror = null;
            URL.revokeObjectURL(fileURL);
          };

          const rejectInvalidVideo = () => {
            cleanup();
            rejectDuration({message: "Video süresi okunamadı."});
          };

          video.preload = 'metadata';
          video.onerror = rejectInvalidVideo;
          video.onseeked = () => {
            const duration = video.duration;
            if (Number.isFinite(duration)) {
              cleanup();
              resolveDuration(duration);
            } else {
              rejectInvalidVideo();
            }
          };
          video.onloadedmetadata = () => {
            if (Number.isFinite(video.duration)) {
              const duration = video.duration;
              cleanup();
              resolveDuration(duration);
            } else {
              try {
                video.currentTime = 7 * 24 * 60 * 60;
              } catch (err) {
                rejectInvalidVideo();
              }
            }
          };
          video.src = fileURL;
        });

        const resetUploadState = () => {
          updateUploadState({status: null, percentage: 0, clearMetadata: true});
        };

        const rejectUpload = err => {
          if (settled) return;
          settled = true;
          cleanupCancelListener();
          resetUploadState();
          reject(err);
        };

        const resolveUpload = result => {
          if (settled) return;
          settled = true;
          cleanupCancelListener();
          resetUploadState();
          resolve(result);
        };

        const cancelCurrentUpload = () => {
          if (settled || cancelRequested) return;

          cancelRequested = true;
          const cancellationError = {message: 'Dosya yükleme işlemin iptal edildi.'};

          if (typeof cancel === 'function') {
            try {
              cancel(cancellationError.message);
            } catch (err) {
              // The upload will still be settled and ignored below.
            }
          }

          if (tempFileReader.readyState === 1) {
            try {
              tempFileReader.abort();
            } catch (err) {
              // FileReader may have completed between the state check and abort.
            }
          }

          rejectUpload(cancellationError);
        };

        const routeCancelledUploadTypes = ['portfolio', 'ticket', 'request', 'order', 'onboarding', 'avatar', 'blog', 'test'];
        cancelUploadHandler = receivedStamp => {
          const cancelsCurrentUpload = receivedStamp === stamp
            || (receivedStamp === 'all' && routeCancelledUploadTypes.includes(type));

          if (!cancelsCurrentUpload) return;
          cancelCurrentUpload();
        };
        EventBus.$on('cancelUpload', cancelUploadHandler);


        const onUploadProgress = (uploadPercentage) => {
          //console.log('uploadPercentage',uploadPercentage);

          if (settled) return;

          const uploadStatus = this.$store.state.uploadStatus || {};
          const currentUploadStatus = (uploadStatus[uploadType] || {})[stamp];
          if (currentUploadStatus) {
            updateUploadState({percentage: uploadPercentage});

            this.$forceUpdate();
          } else {
            cancelCurrentUpload();
          }
        };


        tempFileReader.onload = async (event) => {
          if (settled) return;

          try {
            fileType = fileTyper(new Uint8Array(event.target.result));
          } catch (err) {
            rejectUpload(err);
            return;
          }
          if (fileType) {
            fileType = fileType.mime
          } else {
            fileType = "application/octet-stream";
          }

          const isPortfolioVideo = type === 'portfolio' && (
            fileType.indexOf('video/') === 0 || (file.type && file.type.indexOf('video/') === 0)
          );

          if (isPortfolioVideo) {
            try {
              const duration = await getVideoDuration(file);
              if (settled) return;
              if (!duration || duration > 299) {
                rejectUpload({message:"Video süresi en fazla 4 dakika 59 saniye olabilir."});
                return;
              }
            } catch (err) {
              rejectUpload(err);
              return;
            }
          }

          let uploadRequest;
          try {
            uploadRequest = Api.general.uploadRequest(type, fileName, fileType, fileSize, (type === 'avatar' || type === 'application' ? null : externalID),'google');
          } catch (err) {
            rejectUpload(err);
            return;
          }

          uploadRequest
          .then(({data}) => {
            if (settled) return;

            let result = data;
            if (result.success) {


              console.log('fileType',fileType)
              submitUri = result.data.url;
              let uploadID = result.data.upload_id;
              let uploadName = result.data.upload_name;
              let filename_slug =  result.data.filename_slug;

              let reader = new FileReader();

              updateUploadMetadata(result.data.icon_png, fileName);
              this.$forceUpdate();


              let googleUploadRequestPostOptionsHeaders = {
                  'Content-Type': file.type,
                  'x-goog-resumable': 'start'
              };

              if(result.data.upload_type && result.data.upload_type === 'message'){
                if(result.data.file_type === 'video' && videoDuration > 299){
                  googleUploadRequestPostOptionsHeaders['Content-Disposition'] = 'attachment;filename="'+encodeURIComponent(fileName)+'"';
                } else if(result.data.file_type !== 'video' && result.data.file_type !== 'audio' && result.data.file_type !== 'image'){
                  googleUploadRequestPostOptionsHeaders['Content-Disposition'] = 'attachment;filename="'+encodeURIComponent(fileName)+'"';
                }
              }

              if(result.data.is_not_image && result.data.upload_type && result.data.upload_type === 'request'){
                googleUploadRequestPostOptionsHeaders['Content-Disposition'] = 'attachment;filename="'+encodeURIComponent(fileName)+'"';
              }

              if(result.data.is_not_image && result.data.upload_type && result.data.upload_type === 'ticket'){
                googleUploadRequestPostOptionsHeaders['Content-Disposition'] = 'attachment;filename="'+encodeURIComponent(fileName)+'"';
              }

              if(result.data.upload_type && result.data.upload_type === 'order' && result.data.file_type !== 'audio' && result.data.file_type !== 'image'){
                googleUploadRequestPostOptionsHeaders['Content-Disposition'] = 'attachment;filename="'+encodeURIComponent(fileName)+'"';
              }


              googleUploadRequestPostOptionsHeaders['Cache-Control'] = 'public, max-age=31536000';

              Api.external.uploadFileToGoogle(submitUri, null, googleUploadRequestPostOptionsHeaders,"post")
              .then(result => {
                if (settled) return;

                let putUrl = result.headers.location;
                let googleUploadRequestPutOptions = {
                  headers: {
                    'Content-Type': "multipart/form-data"
                  },
                  onUploadProgress: (progressEvent) => {
                    let uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onUploadProgress(uploadPercentage)
                    if(uploadPercentage % 3 === 0 && type === 'message'){
                      this.api.workstation.sendWriting(externalID, 'uploading', uploadPercentage, r_id, r_uuid);
                    }
                  },
                  cancelToken: new cancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancel = c;
                  })
                };

                let googleUploadRequestPutOptionHeaders = {'Content-Type': "multipart/form-data"};

                Api.external.uploadFileToGoogle(putUrl, file, googleUploadRequestPutOptionHeaders,"put", googleUploadRequestPutOptions)
                .then(function (res2) {
                  if (settled) return;

                  Api.general.updateUploadStatus(uploadID, 1, videoDuration)
                  .then(({data}) => {
                    if (settled) return;

                    let result = data;
                    if (!result.success) {
                      rejectUpload(result);
                      return;
                    }
                    resolveUpload({icon_png:result.data.icon_png,uploadName: uploadName, externalID: result.data.external_id, url: result.data.url, filename: result.data.filename, file_type: result.data.file_type, video_url: result.data.video_url, c_uuid: result.data.c_uuid, image_url:result.data.image_url, image_url_small:result.data.image_url_small,image_url_original:result.data.image_url_original, uuid:result.data.uuid});

                  })
                  .catch(err => {
                    rejectUpload(err);
                  });


                })
                .catch(function (err) {
                  rejectUpload(err);
                });

              })
              .catch(err => {
                rejectUpload(err);
              });
            } else {
              rejectUpload(result)
            }
          })
          .catch(err => {
            rejectUpload(err)
          });
        };

        tempFileReader.onerror = () => {
          rejectUpload({message: "Dosya okunamadı."});
        };
        tempFileReader.onabort = () => {
          rejectUpload({message: "Dosya yükleme işlemin iptal edildi."});
        };

        try {
          tempFileReader.readAsArrayBuffer(file);
        } catch (err) {
          rejectUpload(err);
        }

      });
    },
    cancelUploadRequest(stamp) {
      EventBus.$emit('cancelUpload', stamp);
    },
    calculateElapsedTime(date) {
      let now = new Date()
      let receivedDate = new Date(date)
      const diffMaps = [
        { tr_TR: ' yıl', value: 31536000000 }, // years
        { tr_TR: ' ay', value: 2678400000 }, // months
        { tr_TR: ' gün', value: 86400000 }, // days
        { tr_TR: ' saat', value: 3600000 }, // hours
        { tr_TR: ' dakika', value: 60000 }, // minutes
        { tr_TR: ' saniye', value: 1000 } // seconds
      ]
      let selected = null
      diffMaps.forEach(function (map) {
        if (!selected) {
          let diff = Math.floor((now - receivedDate) / map.value)
          if (diff > 0 ) {
            selected = diff + map.tr_TR
          }
        }
      })

      return selected || 'az önce'
    },
    init(forcedInit, to, from) {
      return new Promise(function (resolve, reject) {
        if (!forcedInit || forcedInit && !store.state.calledInit) {
          Helper.setInitialValuesBeforeInit(to);

          if (isAnalyticsLoaded()) {
            ga('send', 'event', {
              'eventCategory': 'users',
              'eventAction': 'visit'
            });
          }
          store.state.categoriesPromise = Api.general.getAllCategories()
            .then(({ data }) => {
              const categories = data.data.map(category => {
                if (!category.parent_id) {
                  category.subCategory = [];
                  data.data.forEach(tempCategory => {
                    if (category.id === tempCategory.parent_id) {
                      category.subCategory.push(tempCategory)
                    }
                  })
                }
                return category
              })
              store.state.categories = categories
              return categories
            })



          Api.user.speedInit(store.state.deviceToken, store.state.appType, store.state.appVersion, document.referrer, window.location.href)
            .then(({data}) => {
              let received = data;
              if(received.success) {
                if (received.token) {
                  window.localStorage.setItem("token", received.token);
                }

                Helper.setInitialValuesAfterInit(received, to, from);


                if (received.visitor_id) {
                  window.localStorage.setItem("visitor_id", received.visitor_id);
                }

                if (received.data.user) {
                  EventBus.$emit("listenPusherChannelToGetInfoForUser");
                }
                resolve(false);
              } else {
                Api.user.logout().then(({data}) => {
                  let result = data;
                  //LogRocket.identify();
                  localStorage.removeItem("token");
                  localStorage.removeItem("visitor_id");
                  resolve({redirect_url:received.data.redirect_url});
                });
              }
            })
            .catch(function (err) {
              reject(err);
            });
        } else {
          resolve(false);
        }
      })
    },


    playSound(soundUrl) {
      if (this.$store.state.isMobile) return false;
      const playSound = this.$store.state.user.info.permissions.play_sound
      if (playSound && this.$store.state.userInteractedWithDOM) {
        let snd = new Audio(soundUrl)
        let playPromise = snd.play()
        if (playPromise !== undefined) {
          playPromise.catch(function(error) {
            console.error(error + 'Failed to start your sound, retrying.')
          })
        }
      }
    },
    playReceivedMessageSound() {
      this.playSound('https://gcdn.bionluk.com/site/general/gelen.mp3')
    },
    playSentMessageSound() {
      this.playSound('https://gcdn.bionluk.com/site/general/giden.mp3')
    },
    playNotificationSound() {
      this.playSound('https://gcdn.bionluk.com/site/general/gelen.mp3')
    },
    sendPrerender302(redirect_url, type= "301", calledByRouter = false) {

      let meta = document.createElement('meta');
      meta.name = "render:status_code";
      meta.content = type;
      document.getElementsByTagName('head')[0].appendChild(meta);


      let metaLocation = redirect_url;
      if(metaLocation === '/'){
        metaLocation = '';
      }

      //let meta2 = document.createElement('meta');
      //let meta2content = "0,url=https://bionluk.com" + metaLocation;
      //meta2.setAttribute("http-equiv", "refresh");
      //meta2.setAttribute("content", meta2content);
      //document.getElementsByTagName('head')[0].appendChild(meta2);
      let meta3 = document.createElement('meta');
      let meta3content = "Location:https://bionluk.com" + metaLocation;
      meta3.setAttribute("name", "render:header");
      meta3.setAttribute("content", meta3content);
      document.getElementsByTagName('head')[0].appendChild(meta3);
      if(!Helper.isIndexerBotOrDevelopmentEnv() && !calledByRouter){
        this.$router.push(redirect_url)
      }
    },
    escapeTurkishCharacters(word) {
      let turkishMappedChars = {'Ç': 'C', 'ç': 'c', 'Ğ': 'G', 'ğ': 'g', 'İ': 'I', 'ı': 'i', 'Ö': 'O', 'ö': 'o', 'Ş': 'S', 'ş': 's', 'Ü': 'U', 'ü': 'u'};
      let rule = new RegExp(Object.keys(turkishMappedChars).join("|"), "g");

      return word.replace(rule, function (matched) {
        return turkishMappedChars[matched];
      });
    },
    revertLikeStatus(collection) {
      if (collection.likeStatus.action === this.imageUrls.likeIcon.action) {
        collection.likeStatus = {
          actionIcon: this.imageUrls.likeIcon.url,
          action: this.imageUrls.likeIcon.action,
          actionText: this.imageUrls.likeIcon.text
        };
        collection.totalLikes -= 1;
      } else {
        collection.likeStatus = {
          actionIcon: this.imageUrls.likedIcon.url,
          action: this.imageUrls.likedIcon.action,
          actionText: this.imageUrls.likedIcon.text
        };
        collection.totalLikes += 1;
      }
    },
    reverseLikeStatus(collection) {
      if (collection.likeStatus.action === this.imageUrls.likeIcon.action) {
        collection.likeStatus = {
          actionIcon: this.imageUrls.likedIcon.url,
          action: this.imageUrls.likedIcon.action,
          actionText: this.imageUrls.likedIcon.text
        };
        collection.totalLikes += 1;
      } else {
        collection.likeStatus = {
          actionIcon: this.imageUrls.likeIcon.url,
          action: this.imageUrls.likeIcon.action,
          actionText: this.imageUrls.likeIcon.text
        };
        collection.totalLikes -= 1;
      }
    },
    routeBack(path, isForced) {
      this.$store.state.isRoutedBack = true;
      if (isForced) {
        this.$router.push(path);
      } else {
        if (this.$store.state.route.from.fullPath === "/" || this.$store.state.mobileRoutes.length === 0) {
          this.$router.push('/');
        } else {
          let path = this.$store.state.mobileRoutes.pop();
          this.$router.push(path);
        }
      }
    },
    trackConversionForRegisteredUsers() {
      if (!Helper.isIndexerBotOrDevelopmentEnv()) {
        if (isMarketingLoaded()) {
          try {
            trackGoogleConversion({
              google_conversion_id: 962810877,
              google_conversion_language: "tr",
              google_conversion_format: "3",
              google_conversion_color: "ffffff",
              google_conversion_label: "lphnCIzRmWAQ_aeNywM",
              google_remarketing_only: false
            });
          } catch (err) {

          }
        }

        if (isAnalyticsLoaded()) {
          try {
            ga('send', 'event', {
              'eventCategory': 'users',
              'eventAction': 'signup'
            });
          } catch (err) {

          }
        }

        if (isMarketingLoaded()) {
          try {
            fbq('track', 'CompleteRegistration');
          } catch (err) {

          }
        }

        //LogRocket.track('Registered');
      }
    },
    trackConversionForCheckoutedOrders(amount, currency) {
      if (!Helper.isIndexerBotOrDevelopmentEnv()) {
        if (isMarketingLoaded()) {
          try {
            trackGoogleConversion({
              google_conversion_id: 962810877,
              google_conversion_language: "tr",
              google_conversion_format: "3",
              google_conversion_color: "ffffff",
              google_conversion_label: "mLlRCKWX9HoQ_aeNywM",
              google_conversion_value: amount,
              google_conversion_currency: currency,
              google_remarketing_only: false
            });
          } catch (err) {

          }
        }

        if (isMarketingLoaded()) {
          try {
            fbq('track', 'InitiateCheckout', {
              value: amount,
              currency: currency
            });
          } catch (err) {

          }
        }

        if (isAnalyticsLoaded()) {
          try {
            ga('send', 'event', {
              'eventCategory': 'users',
              'eventAction': 'checkout',
              'eventValue': amount
            });
          } catch (err) {

          }
        }

        //LogRocket.track('InitiateCheckout');
      }
    },
    trackConversionForPayedOrders(conversion, expectedType = 'order') {
      // Never substitute checkout prices or invent IDs when an older API omits this payload.
      if (!conversion || !['order', 'freelancer'].includes(expectedType)
        || conversion.type !== expectedType || conversion.currency !== 'TRY') {
        return;
      }
      const idPattern = expectedType === 'order' ? /^order-[1-9][0-9]{0,9}$/ : /^payment-[1-9][0-9]{0,9}$/;
      if (typeof conversion.transaction_id !== 'string' || !idPattern.test(conversion.transaction_id)
        || (typeof conversion.value !== 'number' && typeof conversion.value !== 'string')) {
        return;
      }
      const amount = Number(conversion.value);
      if (!Number.isFinite(amount) || amount <= 0) {
        return;
      }
      const currency = conversion.currency;
      const conversionLabel = expectedType === 'order' ? 'FzE-CPPdhWsQ_aeNywM' : 'k3KzCKrak_UBEP2njcsD';
      const gaEvent = expectedType === 'order' ? 'order payed' : 'freelancer payment';
      // A tag/SDK failure must not turn a successful payment into an error in the UI.
      try {
        if (Helper.isIndexerBotOrDevelopmentEnv()) {
          return;
        }
        if (isMarketingLoaded()) {
          trackGoogleConversion({
            google_conversion_id: 962810877,
            google_conversion_language: "tr",
            google_conversion_format: "3",
            google_conversion_color: "ffffff",
            google_conversion_label: conversionLabel,
            google_conversion_value: amount,
            google_conversion_currency: currency,
            google_conversion_order_id: conversion.transaction_id,
            google_remarketing_only: false
          });
        }
      } catch (err) {
        // Payment remains successful even if measurement is unavailable.
      }
      try {
        if (!Helper.isIndexerBotOrDevelopmentEnv() && isMarketingLoaded()) {
          if (expectedType === 'order') {
            fbq('track', 'Purchase', { value: amount, currency: currency });
          } else {
            fbq('trackCustom', 'FreelancerPayment', { value: amount, currency: currency });
          }
        }
      } catch (err) {
        // Keep other payment observers independent of the Facebook SDK.
      }
      try {
        if (!Helper.isIndexerBotOrDevelopmentEnv() && isAnalyticsLoaded()) {
          ga('send', 'event', {
            'eventCategory': 'users',
            'eventAction': gaEvent,
            'eventValue': amount
          });
        }
      } catch (err) {
        // Analytics must not interrupt checkout completion.
      }
    },
    setFacebookMetaProperties(facebookMeta) {
      for (let key in facebookMeta) {
        document.querySelector(`meta[property="${key}"]`).setAttribute("content", facebookMeta[key]);
      }
    },
    setRedirectURLToRouterMap(path, redirectURL) {
      for (let key in this.$store.state.routerMap) {
        if (key === path) {
          this.$store.state.routerMap[path].redirect_url = redirectURL;
        }
      }
    },
    reloadToMainPage() {
      window.location.href = window.location.origin;
    },
    findCategoryBySlug(slug) {
      return store.state.categoriesPromise.then(() => {
        return this.categories.find(category => category.slug === slug)
      })
    },
    findCategoryByID(id) {
      return store.state.categoriesPromise.then(() => {
        return this.categories.find(category => category.id === id)
      })
    },
    findCategoryBySlugSync(slug) {
      return this.categories.find(category => category.slug === slug)
    },
    findCategoryByIDSync(id) {
      return this.categories.find(category => category.id === id)
    },
    async searchDeeds2(option) {
      const { data } = await NodeApi.post('/search/deeds', option)
      return data
    },
    async searchUsers(option) {
      const { data } = await NodeApi.get('/search/users', { params: option })
      return data
    }
  },
  computed: {
    parentCategories() {
      return this.categories.filter(cat => !cat.parent_id)
    },
    windowHeight() {
      if (this.$store) {
        return this.$store.state.windowHeight;
      }
    },
    api() {
      return Api;
    },
    EventBus() {
      return EventBus;
    },
    Helper() {
      return Helper;
    },
    Constants() {
      return Constants;
    },
    Modals() {
      return Modals;
    },
    types() {
      return Types;
    },
    ...mapState([
      'isLoggedIn',
      'route',
      'user',
      'prefixPath',
      'percentCompleted',
      'footer_links',
      'units',
      'categories',
      'imageUrls',
      'isMobile',
      'deviceType',
      'isRoutedBack',
      'activeTabBar',
      'routerParams',
      'indexHTMLTitle',
      'indexHTMLMetaDescription'
    ])
  }
}
